import { CloudCommand } from "../types.js";

export const getEvent: CloudCommand = {
    action: "EVENTS/GET_EVENT",
    commandName: "events.getEvent",
    buildPayload: ({ id }) => ({ id }),
};
